module.exports = __webpack_public_path__ + "static/img/news2_6.f60321a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/news2_6.png
// module id = DY5z
// module chunks = 0